import 'regenerator-runtime/runtime';
import { html, LitElement, property, TemplateResult, unsafeCSS } from 'lit-element';
import css from './graphical-progress-item.scss';

export default class ApxGraphicalProgressItem extends LitElement {
  @property({ type: String, attribute: 'status' })
  public status = '';

  @property({ type: String, attribute: 'graphic' })
  public graphic = '';

  @property({ type: String, attribute: 'heading' })
  public heading = '';

  @property({ type: String, attribute: 'text' })
  public text = '';

  @property({ type: String, attribute: 'id-prefix' })
  public idPrefix = '';

  public createRenderRoot(): this {
    return this;
  }

  public render(): TemplateResult {
    const { heading, text, status, idPrefix } = this;
    let { graphic } = this;
    const headerOnly = text ? '' : 'apx-graphical-progress-header-only';
    const textTemplate = text
      ? html`
          <div class="apx-graphical-progress-item-text" id="${idPrefix}-graphical-progress-item-text">${text}</div>
        `
      : '';
    if (status === 'complete' && !graphic) {
      // data URI that has had <, >, &, %, # characters URI encoded and uses single quotes for attributes in the SVG instead of double
      graphic = `data:image/svg+xml,%3csvg viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='30' cy='30' fill='%23568200' r='30'/%3e%3cpath d='M43.08 21.54L23.46 40l-6.54-6.59' fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e%3c/svg%3e`;
    }
    const graphicTemplate = graphic
      ? html`
          <img
            src="${graphic}"
            aria-hidden="true"
            class="apx-graphical-progress-item-image"
            id="${idPrefix}-graphical-progress-item-image"
          />
        `
      : '';

    return html`
      <style>
        ${unsafeCSS(css)}
      </style>
      <div class="apx-graphical-progress-item-image-wrapper">${graphicTemplate}</div>
      <div class="${headerOnly}">
        <div class="apx-graphical-progress-item-header" id="${idPrefix}-graphical-progress-item-header">${heading}</div>
        ${textTemplate}
      </div>
    `;
  }
}

// it is required to do it this way instead of using the customElements decorator
// as this component may be imported numerous times
if (!window.customElements.get('apx-graphical-progress-item')) {
  window.customElements.define('apx-graphical-progress-item', ApxGraphicalProgressItem);
}
